export default __webpack_public_path__ + "static/media/vitiligo-surgery.fa120297.pdf";